// removed by extract-text-webpack-plugin
module.exports = {"Content":"NewPassword-module__Content__2fpew","FooterWrapper":"NewPassword-module__FooterWrapper__2WCFG","Footer":"NewPassword-module__Footer__UWoz-","Focused":"NewPassword-module__Focused__1TjNy","SpinnerWrapper":"NewPassword-module__SpinnerWrapper__3aJNi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Auth/PasswordRecovery/NewPassword/NewPassword.module.css
// module id = 1775
// module chunks = 31